const path = require('path');

const convertMap = {
	'cn': 'zh-CN'
};

/** @type {import('next-i18next').UserConfig} */
const i18n = {
	defaultLocale: process.env.APP_DEFAULT_LOCALE || 'uk',
	locales: process.env.APP_LOCALES ? process.env.APP_LOCALES.toString().split(',').filter(d => d) : ['en', 'uk', 'ru'],
	localeDetection: false,
	reloadOnPrerender: process.env.NODE_ENV === 'development',
	serializeConfig: false,
	localePath: (l, ns) => {
		if (convertMap[l])
		{
			l = convertMap[l];
		}

		let dir = (ns.startsWith(`base-`) ? `./public/base/locales` : `./public/locales`) + `/${l}/${ns}.json`;

		if (typeof window === 'undefined')
		{
			const path = require('path');

			return path.resolve(dir);
		}

		return dir;
	},
	load: 'languageOnly',
	ns: [
		'base-auth',
		'base-common',
		'base-page',
		'base-apidocs',
		'base-blacklist',
		'base-countries',
		'base-dashboard',
		'base-dashboard-api',
		'base-dashboard-package',
		'base-dashboard-promo',
		'base-dashboard-referral',
		'base-faq',
		'base-checker-ip',
		'base-checker-proxy',
		'base-index_pl',
		'base-landing',
		'base-landing-mobile',
		'base-landing-extension',
		'base-landing-residential',
		'base-lang-select',
		'base-reviews',
		'base-support',
		'base-oauth'
	]
};

module.exports = {
	i18n
};